import * as types from "./types";
import { implementSetAllNavTabDetailsMutation } from '../../../../dt-plugins/sidewindow/nav-tab';
import { set } from 'lodash';
export const distributionSupplierMutations = {
    [types.DistributionSupplierData.SET.ALL](state, payload) {
        state.accountDistributionData = payload;
      },
    
      [types.SupplierList.SET.ALL](state, payload) {
        state.supplierList = payload;
      },
      [types.SupplierList.DELETE.SINGLE](state, payload) {
        let list = state.supplierList?.suppliers;
        list = list.filter(e => e.supplier_id !== payload.supplier_id)
        state.supplierList = {
            suppliers: [
            ...list
          ]
        }
      },
     
      ...implementSetAllNavTabDetailsMutation(types.SupplierDetails, 'supplierDetails'),
}